import Vue from 'vue'
import App from './App.vue'
import './styles/app.scss'
import './js/CustomElements.js'
import './js/jquery-1.7.min.js'
import './js/jquery-ui-1.8.11.custom.min.js'
import './js/date.js'
import './js/jquery.weekcalendar.js'
import { library } from "@fortawesome/fontawesome-svg-core"
import { fas } from '@fortawesome/free-solid-svg-icons'
import { createPinia, PiniaVuePlugin } from 'pinia'

library.add(fas);

Vue.config.productionTip = false
Vue.use(PiniaVuePlugin);
const pinia = createPinia();

new Vue({
  render: h => h(App),
  pinia
}).$mount('#app')
